import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { loadTags } from '../../services/api';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const noTags = {
  id: 'no-tags',
  name: 'No tags',
  color: '#ff0000', // Red color for "No tags"
}

export default function TableNavigationSearchTags({ userStore, selectedTags, setSelectedTags }) {
  const theme = useTheme();
  const [tags, setTags] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  function getStyles(tag) {
    return {
      fontWeight:
        selectedTags.find(t => t.id === tag.id)
          ? theme.typography.fontWeightMedium
          : theme.typography.fontWeightRegular,
    };
  }

  React.useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        // Replace this URL with your actual API endpoint
        const response = await loadTags(userStore.token);
        setTags([noTags, ...response.data.data]);
        setError(null);
      } catch (err) {
        console.error('Error fetching tags:', err);
        setError('Failed to load tags. Please try again later.');
        setTags([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTags();
  }, []);

  const handleChange = (event) => {
    const { value } = event.target;

    if (value.find(tag => tag.id === noTags.id)) {
      // If "No tags" is selected, clear all other selections
      setSelectedTags([noTags]);
      return;
    }

    setSelectedTags([...value]);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id='tags-select-input'>Tags</InputLabel>
        <Select
          labelId='tags-select-input'
          id='tags-select'
          multiple
          value={selectedTags}
          onChange={handleChange}
          input={<OutlinedInput id='select-multiple-chip' label='Tags' />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => {
                const selectedTag = tags.find(tag => tag.id === value.id);
                return selectedTag ? (
                  <Chip key={value} label={selectedTag.name} style={{backgroundColor: selectedTag.color, color: 'white'}} />
                ) : null;
              })}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {loading ? (
            <MenuItem disabled>Loading tags...</MenuItem>
          ) : error ? (
            <MenuItem disabled>{error}</MenuItem>
          ) : tags.length === 0 ? (
            <MenuItem disabled>No tags available</MenuItem>
          ) : (
            tags.map((tag) => (
              <MenuItem
                key={tag.id}
                value={tag}
                style={getStyles(tag)}
              >
                {tag.name}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </div>
  );
}
